import { get, isString, isNil, find, isObject, last } from 'lodash';
import { Application, downloads } from '@integro/core';

export interface IAttachmentData {
  id: string;
  file_type: string;
  file_name: string;
  file_size: number;
}

export class AttachmentsHelper {
  app: Application;

  DEFAULT_FILE_TYPE_ICON = 'vscode-icons:file-type-binary';

  constructor(app: Application) {
    this.app = app;
  }

  downloadAttachmentFromGridCommand(event: object) {
    const id = get(event, 'data.value');
    if (!isString(id)) {
      return;
    }

    const fieldName = get(event, 'data.column.field');
    if (!isString(fieldName)) {
      return;
    }

    const value = get(event, `data.data.${fieldName}`);

    if (!isNil(value) && Array.isArray(value)) {
      const item = find(value, { id }) as IAttachmentData;
      if (item) {
        return this.downloadAttachment(item);
      }
    } else if (isObject(value)) {
      const item = value as IAttachmentData;
      return this.downloadAttachment(item);
    }
  }

  downloadAttachment(data: IAttachmentData) {
    if (!data) {
      return;
    }

    const url = this.app.connections.urlFor('download_attachment', {
      id: data.id,
    });

    return Promise.resolve(downloads.getFileBLOB(url, data.file_name)).then(
      (p) => p && downloads.showFileInNewTab(p.file, p.fileName),
    );
  }

  downloadInvoiceView(invoiceId: string, invoiceNumber: string) {
    if (!invoiceId) {
      return;
    }

    const url = this.app.connections.urlFor('read_invoice_print', {
      id: invoiceId,
    });

    return Promise.resolve(
      downloads.getFileBLOB(url, `${invoiceNumber}.pdf`),
    ).then((p) => p && downloads.showFileInNewTab(p.file, p.fileName));
  }

  getIconClass(data: IAttachmentData) {
    const extension = data.file_name.indexOf('.')
      ? last(data.file_name.split('.'))!.toLowerCase()
      : data.file_name.slice(1, 3);

    return get(
      this.app.config['fileTypeIcons'],
      extension,
      this.DEFAULT_FILE_TYPE_ICON,
    );
  }
}
